module.exports = __webpack_public_path__ + "img/news_list_3.4397470a.jpg";